const splitRemedies = (remedies: string) => {
    return (remedies || "").split(/(^|\n)-\s?/);
  };
  const getRemedyType = (remedy: string) => {
    return remedy.slice(0, remedy.indexOf(" "));
  };
  const getRemedyText = (remedy: string) => {
    return remedy.slice(remedy.indexOf(" ") + 1);
  };
  
  export const getRemedyComments = (remedies: string) =>
    splitRemedies(remedies)
      .filter((remedy) => ["comment", "comment_once"].includes(getRemedyType(remedy)))
      .map(getRemedyText);
  
  export const getCommentType = (remedies: string) => {
    const commentRemedies = splitRemedies(remedies)
      .filter((remedy) => ["comment", "comment_once"].includes(getRemedyType(remedy)));
    
    if (commentRemedies.length === 0) return "comment_once";
    return getRemedyType(commentRemedies[0]);
  };
  
  export const getRemedyAddParagraphs = (remedies: string) =>
    splitRemedies(remedies)
      .filter((remedy) => getRemedyType(remedy)?.startsWith("add_paragraph"))
      .map(getRemedyText);
  
  export const getEditParagraphTracked = (remedies: string) =>
    splitRemedies(remedies)
      .filter((remedy) =>
        getRemedyType(remedy)?.startsWith("edit_tracked")
      )
      .map(getRemedyText);
  
  export const getEditSectionTracked = (remedies: string) =>
    splitRemedies(remedies)
      .filter((remedy) =>
        getRemedyType(remedy)?.startsWith("edit_section_tracked")
      )
      .map(getRemedyText);
  
  export const getEditDocumentTracked = (remedies: string) =>
    splitRemedies(remedies)
      .filter((remedy) =>
        getRemedyType(remedy)?.startsWith("edit_document_tracked")
      )
      .map(getRemedyText);
  
  export const getEditString = (remedies: string) => {
  
    const paragraphTracked = getEditParagraphTracked(remedies);
    const sectionTracked = getEditSectionTracked(remedies);
    const documentTracked = getEditDocumentTracked(remedies);
  
    const tracked = paragraphTracked.length
      ? paragraphTracked
      : sectionTracked.length
      ? sectionTracked
      : documentTracked.length
      ? documentTracked
      : [];
  
    return tracked.length ? tracked.join(", ") : "";
  };
    
  export const buildRemedyString = ({
    comments,
    addParagraphTracked,
    editParagraphTracked,
    editSectionTracked,
    editDocumentTracked,
    commentType = "comment_once",
  }: {
    comments?: string;
    addParagraphTracked?: string;
    editParagraphTracked?: string | null;
    editSectionTracked?: string | null;
    editDocumentTracked?: string | null;
    commentType?: "comment" | "comment_once";
  }) => {
    return [
      ...(comments ? [`- ${commentType} ${comments}`] : []),
      ...(addParagraphTracked
        ? [`- add_paragraph_tracked ${addParagraphTracked}`]
        : []),
      ...(editParagraphTracked
        ? [`- edit_tracked ${editParagraphTracked}`]
        : []),
      ...(editSectionTracked
        ? [`- edit_section_tracked ${editSectionTracked}`]
        : []),
      ...(editDocumentTracked
        ? [`- edit_document_tracked ${editDocumentTracked}`]
        : []),
    ].join("\n");
  };
  
  export const getRemedyEditsType = (remedies: string) => {
  const editParagraphTracked =
    remedies && getEditParagraphTracked(remedies).length > 0
      ? getEditParagraphTracked(remedies)
      : null;
  const editDocumentTracked =
    remedies && getEditDocumentTracked(remedies).length > 0
      ? getEditDocumentTracked(remedies)
      : null;
  const editSectionTracked =
    remedies && getEditSectionTracked(remedies).length > 0
      ? getEditSectionTracked(remedies)
      : null;
  const remedyEditsType = editParagraphTracked
    ? "edit_tracked"
    : editSectionTracked
    ? "edit_section_tracked"
      : "edit_document_tracked";
    return remedyEditsType
  }
  